import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserChecked = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16 22V21C16 18.7909 14.2091 17 12 17H6C3.79086 17 2 18.7909 2 21V22",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 10,
			r: 4,
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 2L17.1875 6.66667L15 4.33333",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "square"
		})
	]
});
export default SvgUserChecked;
